import $ from 'jquery'
import Swiper from './utils/getSwiper'

function init () {
  $('.tab-search-page').each(function () {
    initSlider($(this))
    truncateIntrotext()
  })
}

function initSlider (container) {
  let navigationBar = container.find('.tab-swiper-js'),
    searchResultPages = container.find('.image-swiper-js'),
    slidingSearchResultPages

  let slidingNavigationBar = new Swiper(navigationBar.get(0), {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 300,
    watchSlidesProgress: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchOverflow: true,
    breakpoints: {
      // when window width is <= 992px md
      992: {
        allowTouchMove: true,
      },
      // when window width is <= 768px sm
      768: {
        allowTouchMove: true,
      },
      576: {
        allowTouchMove: true,
      }
    },
    on: {
      slideChange: function () {
        setTimeout(function () {
          setMobileActive()
        }, 300)
      }
    }
  })

  getSearchResultPage()

  $(window).on('resizeend', function () {
    var currentSlide = slidingSearchResultPages.activeIndex

    slidingSearchResultPages.destroy(false, true)
    getSearchResultPage(currentSlide)
  })

  function getSearchResultPage (activeIndex) {
    if (!activeIndex) {
      activeIndex = 0
    }
    slidingSearchResultPages = new Swiper(searchResultPages.get(0), {
      slidesPerView: '1',
      initialSlide: activeIndex,
      centeredSlides: true,
      fadeEffect: {
        crossFade: true
      },
      speed: 0,
      effect: 'fade',
      allowTouchMove: false,
      autoScaleSlider: true,
      watchSlidesVisibility: true,
      breakpoints: {
        992: {
          autoHeight: true,
        }
      }
    })
  }

  navigationBar.find('.swiper-slide').each(function () {
    $(this).on('click', function () {
      let index = $(this).data('swiper-index')
      navigationBar.find('.swiper-slide').removeClass('active')
      $(this).addClass('active')
      slidingSearchResultPages.slideTo(index)
      if ($(window).width() > 576) {
        slidingNavigationBar.slideTo(index)
      }
    })
  })

  function setMobileActive (direction) {
    if ($(window).width() <= 576) {
      let index = navigationBar.find('.swiper-slide-active').data('swiper-index')
      navigationBar.find('.swiper-slide').removeClass('active')
      navigationBar.find('.swiper-slide-active').addClass('active')
      slidingSearchResultPages.slideTo(index)
    }
  }
}

function truncateIntrotext () {
  let introElem = $('.article-tile .box-content .intro-text')
  introElem.each(function () {
    let introText = $(this).text()

    if (introText && introText.length > 125) {
      let truncatedText = introText.substring(0, 120) + '...'
      $(this).text(truncatedText)
    }
  })
}

export default {
  init
}
